import React from "react";
import Layout from "components/Layout";
import Widget from "components/Widget";
import TypeTable from "components/Table/List";
import DeleteConfirm from "components/Modal/DeleteConfirm";
import EditType from "./components/EditType";
import TableAction from "components/Table/Actions/ActionDropdown";
import AddType from "./components/AddType";
import ShowModal from "components/Modal/ShowModal";
import UploadCSV from "components/uploadCSV";
import SearchBox from "components/Filters/SearchBox";
import { Tag } from "antd";

const Index = () => {
  const columns = [
    {
      title: "Type Name",
      render: (record) => <span>{record.triggerTypeName}</span>,
      key: "typeName",
      width: "120px",
    },
    {
      title: "Trigger Subtitle",
      render: (record) => <span>{record.triggerSubtitle || "----"}</span>,
      key: "typeName",
      width: "120px",
    },
    {
      title: "Info Text",
      render: (record) => <span>{record.triggerTypeInfoText}</span>,
      key: "infoText",
    },
    {
      title: "Type Description",
      render: (record) => <span>{record.triggerTypeDesc}</span>,
      key: "typeDescription",
    },
    {
      title: "Graph Description",
      render: (record) => <span>{record.triggerGraphDesc}</span>,
      key: "graphDescription",
    },
    {
      title: "",
      render: (record) => <TableAction menu={renderActions(record)} />,
      key: "action",
      width: 50,
    },
  ];

  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column">
        <ShowModal
          record={record}
          modalName={"Edit_Type_Modal"}
          buttonName="Edit"
        />
        <DeleteConfirm
          type="deleteTriggerType"
          method="DELETE"
          selectedItem={record}
          apiRequest="DeleteRecord"
          recordName="typeList"
          buttonName="Yes"
          oKText="Delete"
          title="Are you sure you want to delete this Type?"
          Icon="Delete"
        />
      </div>
    );
  };

  return (
    <Layout>
      <Widget
        styleName="mainTable"
        title={
          <div className="gx-d-flex gx-flex-column">
            <span>TRIGGER TYPES</span>
            <a
              className="gx-m-0"
              href="https://painles.s3.amazonaws.com/1654281296973-triggerType-1%20-%20Sheet1.csv"
            >
              <Tag className="gx-m-0" color="blue">
                Download CSV Sample
              </Tag>
            </a>
          </div>
        }
        extra={
          <div className="gx-d-flex" style={{ gap: "20px" }}>
            <SearchBox
              apiName="getTriggerTypes"
              recordName="typeList"
              requestType="FetchRecord"
              customQuery={{ query: "search", key: "name" }}
              placeholder="Search By Name/InfoText"
              width="200px"
            />

            <UploadCSV
              type="getTriggerTypes"
              url="bulkImportSkills"
              table="TriggerType"
              recordName="typeList"
              cb="triggerTypeName"
              uId="triggerId"
            />
            <AddType />
          </div>
        }
      >
        <TypeTable
          apiName="getTriggerTypes"
          recordName="typeList"
          scroll={true}
          pagination={true}
          columns={columns}
        />
      </Widget>
      <EditType />
    </Layout>
  );
};
export default Index;
